import { Dialog, type DialogProps } from '@progress/kendo-react-dialogs'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'
import { type SortValue } from '~/utils'

import styles from './SortDialog.css'
import { SortDialogItem, type SortDialogItemProps } from './SortDialogItem'

export type SortDialogProps<ColumnKey extends string> = {
  items: SortDialogItemProps<ColumnKey>['item'][]
  onChange?: SortDialogItemProps<ColumnKey>['onChange']
  onClose?: DialogProps['onClose']
  value: SortValue<ColumnKey> | null
}

export const SortDialog = <ColumnKey extends string>({
  items,
  onChange,
  onClose,
  value,
}: SortDialogProps<ColumnKey>) => {
  const { t } = useTranslation()

  return (
    <Dialog className={styles.root} title={t('sort_order')} onClose={onClose}>
      <VStack spacing={4}>
        <Typography variant="normal">
          {t('click_to_select_the_order_of_columns_for_sorting')}
        </Typography>

        <VStack spacing={2}>
          {items.map((item) => (
            <SortDialogItem
              key={item.columnKey}
              item={item}
              value={value}
              onChange={onChange}
            />
          ))}
        </VStack>
      </VStack>
    </Dialog>
  )
}
